import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'reactstrap'

const Accordion = ({ items, defaultOpenIndex = null }) => {
  const [openIndexes, setOpenIndexes] = React.useState(() => {
    if (defaultOpenIndex === null || defaultOpenIndex === undefined) {
      return new Set()
    }
    return new Set([Number(defaultOpenIndex)])
  })

  const toggle = index => {
    setOpenIndexes(prev => {
      const next = new Set()
      if (prev.has(index)) {
        next.delete(index)
      } else {
        next.add(index)
      }
      return next
    })
  }

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const isOpen = openIndexes.has(index)
        const headerId = `accordion-header-${index}`
        const contentId = `accordion-content-${index}`

        return (
          <div
            id={`accordion-item-${index}`}
            key={index}
            className="accordion-item"
          >
            <button
              type="button"
              id={headerId}
              aria-expanded={isOpen}
              aria-controls={contentId}
              onClick={() => toggle(index)}
              className="accordion-header"
            >
              <span>{item.title}</span>
              <span
                className={`accordion-chevron pl-1${isOpen ? ' is-open' : ''}`}
                aria-hidden="true"
              >
                <i className="fas fa-chevron-down icon-black" />
              </span>
            </button>
            <Collapse isOpen={isOpen}>
              <div
                id={contentId}
                role="region"
                aria-labelledby={headerId}
                className="accordion-content"
              >
                {item.content}
              </div>
            </Collapse>
          </div>
        )
      })}
    </div>
  )
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    }).isRequired
  ).isRequired,
  defaultOpenIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Accordion
